<button [ngClass]="buttonClasses" [type]="type" [disabled]="isPending || disabled" (click)="onClick.next()">
  <div [class.label-hidden]="isPending">
    <ng-content></ng-content>
  </div>
  @if (isPending) {
    <app-spinner [type]="$any(spinnerType)" [class.ie-browser]="isIEBrowser"></app-spinner>
  }
</button>
